import React, { useEffect, useState } from "react";
import {
  Chart,
  CommonSeriesSettings,
  Series,
  ArgumentAxis,
  Grid,
  Crosshair,
  Export,
  Legend,
  Point,
  Label,
  Font,
  Tooltip,
  ValueAxis,
} from 'devextreme-react/chart';
import { Button } from 'devextreme-react/button';
import DateFilter from "../../date-filter/DateFilter";
import DateRange from "../../date-range/DateRange";
import STATISTICS_API from "api/statisticsApi";
import { useSelector } from "react-redux";
import dayjs from 'dayjs';
import { useNavigate } from "react-router-dom";
import { useFetch } from "@hooks/useStatApi";
import { LoadPanel } from 'devextreme-react/load-panel';
import { LoadIndicator } from "devextreme-react";
import { Popup } from 'devextreme-react/popup'; // Import Popup for modal

const energySources = [
  { value: 'avgPurchasePricePerKg', name: 'Purchase Price' },
  { value: 'avgSalesPricePerKg', name: 'Sales Price' },
  // { value: 'avgVolumePerKg', name: 'Volume' },
  { value: 'avgClaimsPricePerKg', name: 'Claim Price' }, // <-- you missed this
];



function CrossHair({ batchNo, type = {}, supplierId:  supplierIdProp, batchId = {}, sDate, eDate, filter }) {
  const today = dayjs().startOf('day');
  const oneWeekAgo = today.subtract(1, 'week');
  const supplierId =  supplierIdProp || localStorage.getItem('supplierId');
  const shouldFetch = supplierId !== null; // will be null initially, but maybe undefined is also meaningful
  const [mFilter, setMfilter] = useState()
  console.log("sDate", sDate)
  const [isModalVisible, setIsModalVisible] = useState(false); // State to control modal visibility

  const [dateRange, setDateRange] = useState(eDate ? `${sDate} - ${eDate}` : `${oneWeekAgo.format('YYYY-MM-DD')} - ${today.format('YYYY-MM-DD')}`);
  const [selectedFilter, setSelectedFilter] = useState(filter ? filter : '1W');
  const batchID = useSelector((state) => state.overview.batchId);
  const handleRedirect = () => {
    setIsModalVisible(true); // Show the modal instead of opening a new tab

  };
  const closeModal = () => {
    setIsModalVisible(false); // Close the modal
  };
  const [startDate, endDate] = dateRange
    ? dateRange.split(' - ').map(date => dayjs(date, 'YYYY-MM-DD').format('YYYY-MM-DD'))
    : [null, null];
  const params = {

    startDate,
    endDate,
    supplierId,
  };

  const { data: receive, loading: isReceiveLoading, refetch } = useFetch(
    "fetchReceived",
    STATISTICS_API.received,
    (!batchNo && shouldFetch) ? params : null

  );

  const { data: receiveBatch, loading: isReceiveLoadingBatch, } = useFetch(
    "fetchReceivedBatch",
    STATISTICS_API.getReceivedBybatch,
    batchNo ? { batchNo, startDate, endDate } : null

  );

  const handleQuickFilter = (filter) => {
    setSelectedFilter(filter);
    setMfilter(filter)

    const today = dayjs().startOf('day'); // Ensure it starts from today

    let fromDate = today.format('YYYY-MM-DD'); // Default to today
    switch (filter) {
      case '1W': fromDate = today.subtract(1, 'week').format('YYYY-MM-DD'); break;
      case '1M': fromDate = today.subtract(1, 'month').format('YYYY-MM-DD'); break;
      case '1Q': fromDate = today.subtract(3, 'month').format('YYYY-MM-DD'); break;
      case '1Y': fromDate = today.subtract(1, 'year').format('YYYY-MM-DD'); break;
      case '2Y': fromDate = today.subtract(2, 'year').format('YYYY-MM-DD'); break;
      default: break;
    }

    console.log(`Filter: ${filter}, From: ${fromDate}, To: ${today.format('YYYY-MM-DD')}`);
    setDateRange(`${fromDate} - ${today.format('YYYY-MM-DD')}`);
  };
  useEffect(() => {
    if (dateRange) refetch();
  }, [dateRange, refetch]);

  return (
    <React.Fragment>

      <div className="lg:flex flex-col lg:flex-row space-y-3 lg:space-y-0 items-center justify-between gap-4 mb-4">
        <div>
          <p className="mb-0 text-xl font-medium">Received</p>
        </div>
        <div>
          <DateFilter mFilter={mFilter} onFilterChange={handleQuickFilter} selectedFilter={selectedFilter} />
        </div>
        <div className="flex justify-between items-center">
          <DateRange onDateChange={(newRange) => {
            setDateRange(newRange);
            setSelectedFilter(null); // <--- RESET selectedFilter
          }} dateRange={dateRange} />
          {
            type != "full" ?
              <Button onClick={handleRedirect} className="ms-2"
                icon="fullscreen"
              />
              : null}
        </div>
      </div>

      {
        receive?.data?.length || receiveBatch?.data?.length > 0 ?


          <Chart
            id="chart"
            dataSource={receiveBatch?.data?.length > 0 ? receiveBatch?.data : (receive?.data?.length && receive?.data)}
          >
            <CommonSeriesSettings
              // type="spline"
              type="line"
              argumentField="duration"
            >
              <Point hoverMode="allArgumentPoints" />
            </CommonSeriesSettings>

            {energySources.map((item) => (
              <Series
                key={item.value}
                valueField={item.value}
                name={item.name}
              />
            ))}

            <ArgumentAxis
              valueMarginsEnabled={false}
              discreteAxisDivisionMode="crossLabels"
            >
              <Grid visible={true} />
            </ArgumentAxis>

            <ValueAxis>
              <Label customizeText={(arg) => `€${arg.valueText}`} />
            </ValueAxis>

            <Crosshair enabled={true} color="#949494" width={3} dashStyle="dot">
              <Label visible={true} backgroundColor="#949494" customizeText={(arg) => `€${arg.valueText}`}>
                <Font color="#fff" size={12} />
              </Label>
            </Crosshair>

            <Legend verticalAlignment="bottom" horizontalAlignment="center" itemTextPosition="bottom" />
            <Tooltip enabled={true} />
            <Export enabled={true} formats={['PNG', 'PDF', 'SVG']} fileName="received-chart" />
          </Chart>

          :
          <div className="flex justify-center items-center h-96">
            <p className="no-data-text">No Data Found</p>
          </div>

      }

      <Popup
        visible={isModalVisible}
        onHiding={closeModal}
        dragEnabled={true}
        closeOnOutsideClick={true}
        showTitle={true}
        title="Received"
        
        width="90%"
        height="90%"
      >
        <div className="flex flex-col space-y-4 custom-graphs">
          <div className="lg:flex flex-col lg:flex-row space-y-3 lg:space-y-0 items-center justify-between gap-4">
            <div>
              <DateFilter
                mFilter={mFilter}
                onFilterChange={handleQuickFilter}
                selectedFilter={selectedFilter}
              />
            </div>
            <div>
              <DateRange
                onDateChange={(newRange) => {
                  setDateRange(newRange);
                  setSelectedFilter(null); // Reset selectedFilter
                }}
                dateRange={dateRange}
              />
            </div>
          </div>
          {
            receive?.data?.length || receiveBatch?.data?.length > 0 ?


              <Chart
              height={650}
                id="chart"
                dataSource={receiveBatch?.data?.length > 0 ? receiveBatch?.data : (receive?.data?.length && receive?.data)}
              >
                <CommonSeriesSettings
                  // type="spline"
                  type="line"
                  argumentField="duration"
                >
                  <Point hoverMode="allArgumentPoints" />
                </CommonSeriesSettings>

                {energySources.map((item) => (
                  <Series
                    key={item.value}
                    valueField={item.value}
                    name={item.name}
                  />
                ))}

                <ArgumentAxis
                  valueMarginsEnabled={false}
                  discreteAxisDivisionMode="crossLabels"
                >
                  <Grid visible={true} />
                </ArgumentAxis>

                <ValueAxis>
                  <Label customizeText={(arg) => `€${arg.valueText}`} />
                </ValueAxis>

                <Crosshair enabled={true} color="#949494" width={3} dashStyle="dot">
                  <Label visible={true} backgroundColor="#949494" customizeText={(arg) => `€${arg.valueText}`}>
                    <Font color="#fff" size={12} />
                  </Label>
                </Crosshair>

                <Legend verticalAlignment="bottom" horizontalAlignment="center" itemTextPosition="bottom" />
                <Tooltip enabled={true} />
                <Export enabled={true} formats={['PNG', 'PDF', 'SVG']} fileName="received-chart" />
              </Chart>

              :
              <div className="flex justify-center items-center h-96">
                <p className="no-data-text">No Data Found</p>
              </div>

          }
        </div>
      </Popup>


    </React.Fragment>
  );
}
export default CrossHair;
